import { render } from "./OldCalculateComplexityPopup.vue?vue&type=template&id=6ba00492&scoped=true"
import script from "./OldCalculateComplexityPopup.vue?vue&type=script&lang=js"
export * from "./OldCalculateComplexityPopup.vue?vue&type=script&lang=js"

import "./OldCalculateComplexityPopup.vue?vue&type=style&index=0&id=6ba00492&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba00492"]])

export default __exports__